export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const START_LIST_RENDER = 'START_LIST_RENDER';
export const PRE_POST = 'PRE_POST';
export const TO_MYPORNS = 'TO_MYPORNS';
export const TO_TARGET = 'TO_TARGET';